import { Theme } from '@mui/system'
import { makeStyles } from '@mui/styles'
import { SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  buttonsWrapper: {
    '&&': {
      marginBottom: SPACES.l,

      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexWrap: 'wrap',

      width: '100%',

      [theme.breakpoints.down('tablet')]: {
        gap: SPACES.xl,
        maxWidth: '334px',
      },
      [theme.breakpoints.up('tablet')]: {
        gap: SPACES.xxxl,
        maxWidth: '375px',
      },
    },
  },
  buttonWrapper: {
    '&&': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',

      borderRadius: '50%',
      backgroundColor: theme.palette.custom.white,
      boxShadow: `0px 4px 20px rgba(0, 0, 0, 0.1)`,
      scale: 0.75
    },
  },
}))

export { useStyles }
